import { IcoChevronDown, Lens } from '@icons';
import React, { useRef, useState } from 'react';
import { Button, FormControl } from 'react-bootstrap';
import { FilterFieldType } from './CustomFilter';

interface SearchCheckboxAdvancedFilterProps {
    field: FilterFieldType;
    activeFilters: { [key: string]: (string | number)[] };
    handleFilterSet: (field: FilterFieldType, option: { value: string }, isActive: boolean) => void;
}

const SearchCheckboxAdvancedFilter: React.FC<SearchCheckboxAdvancedFilterProps> = ({ field, activeFilters, handleFilterSet }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleIsOpen = () => setIsOpen(prevIsOpen => !prevIsOpen);
    const [searchTerm, setSearchTerm] = useState("");
    const contentRef = useRef<HTMLDivElement>(null);
    return <>
        <Button
            onClick={toggleIsOpen}
            variant='link'
            style={{
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                textDecoration: "none"
            }}>
            {!isOpen ? "vedi tutti" : "vedi meno"} <IcoChevronDown
                fill='#09a8b0'
                style={{
                    transition: "transform 0.2s",
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)"
                }}
            />
        </Button>
        {(field.options) ? (
            <div style={{
                width: "100%",
                marginBlock: isOpen ? '24px' : '0',
                maxHeight: isOpen ? contentRef.current?.scrollHeight : 0,
                overflow: "hidden",
                transition: "max-height 0.3s ease",
                display: "grid", gap: "8px"
            }}
                ref={contentRef}
            >
                <div style={{
                    position: "relative",
                    marginBottom: "32px",
                    maxWidth: "300px"
                }}>

                    <FormControl
                        type="text"
                        placeholder="Cerca una persona..."
                        id='search-input'
                        value={searchTerm}
                        onChange={(event) => setSearchTerm(event.target.value)}
                    // style={{ maxWidth: "300px" }}
                    />
                    <Lens style={{
                        position: "absolute",
                        top: "50%",
                        right: "12px",
                        transform: "translateY(-50%)"
                    }} />
                </div>
                <div style={{
                    padding: '4px 8px', display: "grid", gap: "16px"
                }}>
                    {field.options.filter(option => option.label.toLowerCase().includes(searchTerm.toLowerCase())).map(option => {
                        const isActive = !!activeFilters[field.queryParamName || field.name]?.includes(option.value);

                        return <div key={option.value} style={{
                            // textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            // whiteSpace: 'nowrap',
                            display: 'flex',
                            alignItems: "center",
                            gap: "8px",
                        }}>
                            <input type="checkbox" id={`filter-${option.value}`}
                                checked={isActive}
                                onChange={() => {
                                    handleFilterSet(field, option, isActive);
                                    // setActiveFilters(prev => {
                                    //     const newFilters = { ...prev };
                                    //     const current = newFilters[fieldName] ?? [];

                                    //     if (current.includes(option.value)) {
                                    //         // rimuovi
                                    //         const updated = current.filter(value => value !== option.value);
                                    //         if (updated.length > 0) {
                                    //             newFilters[fieldName] = updated;
                                    //         } else {
                                    //             delete newFilters[fieldName];
                                    //         }
                                    //     } else {
                                    //         // aggiungi
                                    //         newFilters[fieldName] = [...current, option.value];
                                    //     }

                                    //     return newFilters;
                                    // });
                                }}

                            />
                            <label htmlFor={`filter-${option.value}`} style={{
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                            }}>{option.label}</label>
                        </div>
                    })}
                </div>
            </div>
        ) : null}
    </>
}

export default SearchCheckboxAdvancedFilter